import axios, { AxiosRequestConfig } from 'axios';
import helper from './helper';
// import AbortBus from './abort';
import qs from 'qs';
import { RequestMethod, MIMEType } from './enum';
import IResponseParser from './IResponseParser';
import PlainResponseParser from './impl/PlainResponseParser';

axios.interceptors.request.use((config) => {
    let token = JSON.parse(window.localStorage.getItem('security.token') || '{}').token;
    if (token) {
        config.headers.Authorization = 'Bearer ' + token;
    }
    return config;
}, (error) => {
  return Promise.reject(error);
});

export default class Request {

  /**
   * 请求默认超时时间
   */
  private static readonly defaultTimeout = 100 * 1000;

  /**
   * 发送一个GET异步请求
   * 
   * @param {string} url 请求地址
   * @param {*} params 键值对(url查询参数)
   * @param {(data: any) => Promise} [successCallback] 成功时的回调
   * @param {(error: string) => Promise} [errorCallback] 错误时的回调
   * @memberof Request
   */
  static async get(url: string, params?: any) {
    const config = {
      url,
      method: RequestMethod.get,
      params,
      headers: { 'Accept': MIMEType.json },
    };
    return Request.request(config);
  }

  /**
   * 发送一个PUT异步请求
   * 
   * @param {string} url 请求地址
   * @param {*} params request url的请求数据, 键值对
   * @param {*} data request body的请求数据, 键值对
   * @memberof Request
   */
  static async put(url: string, params?: any, data?: any) {
    const config = {
      url,
      method: RequestMethod.put,
      params,
      data: qs.stringify(data),
      headers: {
        'Accept': MIMEType.json,
        'Content-Type': MIMEType.form,
      },
    };

    return Request.request(config);
  }

  /**
   * 发送一个PUT异步请求
   * 
   * @param {string} url 请求地址
   * @param {*} params request url的请求数据, 键值对
   * @param {*} data request body的请求数据, 键值对
   * @memberof Request
   */
  static async putJson(url: string, params?: any, data?: any) {
    const config = {
      url,
      method: RequestMethod.put,
      params,
      data: data,
      headers: {
        'Accept': MIMEType.json,
        'Content-Type': MIMEType.json,
      },
    };

    return Request.request(config);
  }

  /**
   * 发送一个POST异步请求
   * 
   * @param {string} url 请求地址
   * @param {*} params request url的请求数据, 键值对
   * @param {*} data request body的请求数据, 键值对
   * @memberof Request
   */
  static async post(url: string, params?: any, data?: any) {
    const config = {
      url,
      method: RequestMethod.post,
      params,
      data: qs.stringify(data),
      headers: {
        'Accept': MIMEType.json,
        'Content-Type': MIMEType.form,
      },
    };

    return Request.request(config);
  }

  /**
   * 发送一个POST异步请求
   * 
   * @param {string} url 请求地址
   * @param {*} params request url的请求数据, 键值对
   * @param {*} data request body的请求数据, 键值对
   * @memberof Request
   */
  static async postJson(
    url: string,
    params?: any,
    data?: any,
  ) {
    const defaultConfig = {
      url: url,
      method: RequestMethod.post,
      params: params,
      data: data,
      headers: {
        'Accept': MIMEType.json,
        'Content-Type': MIMEType.json,
      },
    };

    return Request.request(defaultConfig);
  }

  /**
   * 上传文件至文件服务器
   * @param url 
   * @param params 
   * @param data 
   * @param parser 
   */
  static async postToFileServer(
    url: string,
    params?: any,
    data?: any,
    parser?: IResponseParser,
    onUploadProgress?: (progressEvent: any) => void,
  ) {
    const defaultConfig = {
      url: url,
      method: RequestMethod.post,
      params: params,
      data: data,
      headers: {
        'Accept': MIMEType.json,
        'Content-Type': MIMEType.json,
      },
      withCredentials: false,
      onUploadProgress,
    };

    return Request.request(defaultConfig, parser);
  }

  /**
   * 发送一个异步请求
   * 
   * @param {AxiosRequestConfig} config Axios请求配置
   */
  private static async request(config: AxiosRequestConfig, parser?: IResponseParser) {
    config.headers.Title = encodeURIComponent(document.title);
    const defaultConfig: AxiosRequestConfig = {
      timeout: Request.defaultTimeout,
      withCredentials: true,
      // cancelToken: AbortBus.cancelToken,
      ...config,
    };

    const timeout = defaultConfig.timeout || Request.defaultTimeout;
    let asyncResult = axios.request(defaultConfig)
      .then(helper.checkStatus)
      .then(response => {
        if (parser && parser instanceof PlainResponseParser) {
          return parser.parse(response);
        }
        return helper.parseResponse(response);
      }).catch(() => {
        return null;
      });

    return Promise.race([helper.timeout(timeout), asyncResult]);
  }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/utils/http/request/index.ts